module.exports = __webpack_public_path__ + "img/figure2.31572357.png";